/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_HOLIDAYS, GET_HOLIDAYS } from 'src/actions/holidayActions';

const initialState = {
  items: [],
  total: 0,
  isFetching: false,
  message: ''
};

const holidayReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_HOLIDAYS: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_HOLIDAYS: {
      const { holidays, total, message } = action.payload;

      return produce(state, (draft) => {
        draft.items = holidays;
        draft.total = total;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    default: {
      return state;
    }
  }
};

export default holidayReducer;
